<template>
  <div class="config-table">
    <b-table :items="configs" :fields="fields" responsive="sm" small>
      <template #cell(stt)="data">
        {{ data.index + 1 }}
      </template>

      <template #cell(category)="data">
        <b-form-input
          v-if="configId == data.item.id"
          v-model="category"
          type="text"
          placeholder="Category"
        />
        <p v-else>{{ data.value }}</p>
      </template>

      <template #cell(config_key)="data">
        <b-form-input
          v-if="configId == data.item.id"
          v-model="config_key"
          type="text"
          placeholder="config_key"
        />
        <p v-else>{{ data.value }}</p>
      </template>

      <template #cell(type)="data">
        <b-form-select
          v-if="configId == data.item.id"
          v-model="type"
          :options="types"
        />
        <p v-else>{{ getTypeName(data.value) }}</p>
      </template>

      <template #cell(data)="data">
        <b-form-checkbox
          v-if="configId == data.item.id && type == 'boolean'"
          v-model="value"
          class="custom-control-primary"
          name="check-button"
          switch
        >
          <span class="switch-icon-left">
            <feather-icon icon="CheckIcon" />
          </span>
          <span class="switch-icon-right">
            <feather-icon icon="CheckIcon" />
          </span>
        </b-form-checkbox>
        <b-form-input
          v-else-if="configId == data.item.id"
          v-model="value"
          :type="type == 'string' ? 'text' : type"
          placeholder="Value"
        />
        <p v-else>{{ JSON.stringify(data.value.value).length > 50 ? reduceTextLength(data.value.value) : data.value.value }}</p>
      </template>

      <template #cell(action)="data">
        <div class="d-flex">
          <b-button
            @click="editOrUpdateConfig(data.index)"
            size="sm"
            style="margin-right: 5px"
            variant="primary"
          >
            {{ configId == data.item.id ? "Save" : "Edit" }}
          </b-button>
          <b-button
            size="sm"
            variant="danger"
            @click="confirmDelete(data.item.id)"
          >
            {{ configId == data.item.id ? "Cancel" : "Delete" }}
          </b-button>
        </div>
      </template>
    </b-table>
  </div>
</template>
<script>
import service from "../../service";
export default {
  props: {
    configs: { type: Array, required: true },
    types: { type: Array, required: true },
  },
  data() {
    return {
      fields: [
        "stt",
        "category",
        "config_key",
        "type",
        "data",
        { key: "action", label: "" },
      ],
      configId: null,
      config_key: null,
      category: null,
      value: null,
      type: null,
    };
  },
  watch: {
    type: function (newValue) {
      if (newValue == "boolean" && (typeof this.value) != 'boolean') {
        this.value = false;
      }
    },
  },
  methods: {
    async editOrUpdateConfig(index) {
      if (
        !this.configId ||
        (this.configId && this.configId != this.configs[index].id)
      ) {
        this.configId = this.configs[index].id;
        this.config_key = this.configs[index].config_key;
        this.category = this.configs[index].category;
        this.value = (this.configs[index].type === 'object') ? JSON.stringify(this.configs[index].data?.value) : this.configs[index].data?.value;
        this.type = this.configs[index].type;
      } else {
        if (this.type === 'object') {
          this.value = JSON.parse(this.value)
        }
        let dataUpdate = {
          ...this.configs[index],
          key: this.config_key,
          category: this.category,
          value: this.type == "number" ? parseInt(this.value) : this.value,
          type: this.type,
        };
        let response = await service.update(dataUpdate);
        if (response.data.type == "SUCCESS") {
          this.resetData();
          this.$emit("getList");
        }
      }
    },
    async cancelOrDelete(id) {
      if (this.configId == id) {
        this.resetData();
      } else {
        await service.delete({ id: id });
        this.$emit("getList");
      }
    },
    confirmDelete(id) {
      this.$bvModal
        .msgBoxConfirm("Are you sure ?", {
          title: "Please Confirm",
          size: "md",
          okVariant: "danger",
          okTitle: "Yes",
          cancelTitle: "No",
          cancelVariant: "outline-secondary",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value === true) {
            this.cancelOrDelete(id);
          }
        });
    },
    resetData() {
      this.configId = null;
      this.config_key = null;
      this.category = null;
      this.value = null;
    },
    getTypeName(value) {
      let findType = this.types.find((type) => type.value == value);
      return (findType && findType.text) || "";
    },
    reduceTextLength(text){
      text = JSON.stringify(text);
      return text.slice(0, 50)+"..."
    }
  },
};
</script>
<style lang="scss">
.config-table {
  table {
    td {
      padding-top: 0.72rem !important;
      padding-bottom: 0.72rem !important;
      p {
        margin: unset;
      }
    }
  }
}
</style>
